import { render, staticRenderFns } from "./shipinbs6.vue?vue&type=template&id=50bf16f6&scoped=true"
import script from "./shipinbs6.vue?vue&type=script&lang=js"
export * from "./shipinbs6.vue?vue&type=script&lang=js"
import style0 from "./shipinbs6.vue?vue&type=style&index=0&id=50bf16f6&prod&lang=less"
import style1 from "./shipinbs6.vue?vue&type=style&index=1&id=50bf16f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf16f6",
  null
  
)

export default component.exports